import React from 'react'

export default function Button({className,children,onClick}) {
  return (
    <button
    className={`bg-blue-400 text-white text-base px-3 py-1 rounded hover:bg-blue-700 ${className}`}
    onClick={onClick}
    >{children}</button>
  )
}
